'use client'

import React, { useEffect, useMemo, useState } from 'react'

import { XGlyph } from 'Assets/Svg/Icons'

import { Header, StyledModal, StyledModalProps, XButton } from './styles'

type Props = Omit<StyledModalProps, 'isOpen' | 'overlayClassName'> & {
  children?: React.ReactNode
  closeButton?: boolean
  isOpen?: boolean
  shouldCloseOnOverlayClick?: boolean
  onClose?: () => void
}

function Modal({
  children,
  closeButton = true,
  isOpen = false,
  shouldCloseOnOverlayClick = true,
  onClose,
  ...rest
}: Props) {
  const [mounted, setMounted] = useState(false)

  const rootElement = useMemo(() => {
    if (!mounted) return undefined

    return window.document.getElementById('root')
  }, [mounted])

  useEffect(() => {
    setMounted(true)
  }, [])

  React.useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }

    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [isOpen])

  if (!mounted || !rootElement) return null

  return (
    <StyledModal
      {...rest}
      appElement={rootElement}
      isOpen={isOpen}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      onRequestClose={onClose}
    >
      {closeButton && (
        <Header>
          <XButton onClick={onClose}>{XGlyph()}</XButton>
        </Header>
      )}

      {children}
    </StyledModal>
  )
}

export default Modal
